var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 16,
    fill: "#FFF5E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.42 40.4201C69.92 37.9201 68.78 35.0001 67.42 33.5801L61.42 27.5801C58.9 25.0801 56 26.2201 54.58 27.5801L51.18 31.0001H46C42.2 31.0001 40 33.0001 38.88 35.3001L30 44.1801V52.1801L28.58 53.5801C26.08 56.1001 27.22 59.0001 28.58 60.4201L34.58 66.4201C35.66 67.5001 36.82 67.9001 37.92 67.9001C39.34 67.9001 40.64 67.2001 41.42 66.4201L46.82 61.0001H54C57.4 61.0001 59.12 58.8801 59.74 56.8001C62 56.2001 63.24 54.4801 63.74 52.8001C66.84 52.0001 68 49.0601 68 47.0001V41.0001H66.82L67.42 40.4201ZM64 47.0001C64 47.9001 63.62 49.0001 62 49.0001H60V51.0001C60 51.9001 59.62 53.0001 58 53.0001H56V55.0001C56 55.9001 55.62 57.0001 54 57.0001H45.18L38.62 63.5601C38 64.1401 37.64 63.8001 37.42 63.5801L31.44 57.6201C30.86 57.0001 31.2 56.6401 31.42 56.4201L34 53.8201V45.8201L38 41.8201V45.0001C38 47.4201 39.6 51.0001 44 51.0001C48.4 51.0001 50 47.4201 50 45.0001H64V47.0001ZM64.58 37.5801L61.18 41.0001H46V45.0001C46 45.9001 45.62 47.0001 44 47.0001C42.38 47.0001 42 45.9001 42 45.0001V39.0001C42 38.0801 42.34 35.0001 46 35.0001H52.82L57.38 30.4401C58 29.8601 58.36 30.2001 58.58 30.4201L64.56 36.3801C65.14 37.0001 64.8 37.3601 64.58 37.5801Z",
    fill: "#F0A81A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/Feature4.18d722c17ab42795149bea646e89177d.svg";
export { ForwardRef as ReactComponent };